module.exports = __webpack_public_path__ + "static/media/resultados_sobre_pobreza_2.bce63422.png";